import React, { useEffect } from 'react'
import TopBar from '../../components/TopBar'
import { Container } from '@mui/system'
import TableRow from '@mui/material/TableRow'
import HomeHeader from '../../components/HomeHeader'
import { Grid, Typography, Box } from '@mui/material'
import './style.scss'
import HomeTopBar from '../../components/HomeTopBar'
import Footer from '../../components/Footer'
import BookingDetails from '../Booking/BookingDetails'
import Hoursupport from '../../assets/images/24hour-support.png'
import benz_van from '../../assets/images/benz_van.png'
import bmw_one from '../../assets/images/bmw_one.png'
import world_wide from '../../assets/images/world_wide.png'
import car_3 from '../../assets/images/car_3.png'
import pngwing_1 from '../../assets/images/pngwing_1.png'
import Gps from '../../assets/images/gps.png'
import Excellent from '../../assets/images/excellent.png'
import safe_secure from '../../assets/images/safe_secure.png'
import best_quality from '../../assets/images/best_quality.png'
import car from '../../assets/images/car.png'
import BookingForm from './BookingForm'
import { useDispatch, useSelector } from 'react-redux'
import { BOOKING_INPUT, COUPON_VERIFY_FAIL } from '../../Redux/constants/bookingConstants';
import { isEmpty } from 'lodash';
import { Button } from '@mui/material'
import { redirect, useNavigate } from 'react-router-dom'

import AboutUs from '../../assets/images/about-us.png'
import ServiceOne from '../../assets/images/service-one.png'
import ServiceTwo from '../../assets/images/service-two.png'
import ServiceThree from '../../assets/images/service-three.png'
import ServiceCar from '../../assets/images/sevice_slide_car.jpg'
import ServiceBus from '../../assets/images/sevice_slide_bus.jpg'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const Home = () => {
    //process.env.REACT_APP_GOOGLE_KEY

    const navigation = useNavigate()

    const { user } = useSelector(state => state.auth)
    const dispatch = useDispatch()
    useEffect(() => {
        deleteBooking()
    }, [user])

    const deleteBooking = () => {
      
        // let orderDatas = orderData.filter((or, i) => i !== index)
        let orderDatas ='';
        dispatch({
            type: BOOKING_INPUT,
            payload: {
                prop: 'orderData',
                value: orderDatas
            }
        })

    }

    useEffect(() => {
        if (user) {
            navigation('/dashboard')
        }
    }, [user])

    
 // carousel
 const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

    return (
        <div>
            <Grid className=''>
            <div className="mainHeader">
                    {/* <HomeHeader /> */}
                    <HomeTopBar activeMenu='1' />
            </div>
            </Grid>

            <div className="homeBackground" id='mainhome'>
                <Grid className='padd-r-l'>
                <Grid className='main-head-con' container sx={{ height: '100vh', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', flexWrap: 'wrap', alignItems: 'top' }}>
                    <Grid xs={12} md={6} sx={{}} >
                        {/* <h1 className='heading main-head' xs={{fontSize : '22px'}} >Luxury Life Style Rentals</h1> */}
                        <h1 className='heading main-head' xs={{fontSize : '22px'}} >LUXURY</h1>
                        <h2 className='sub-heading'>CAR BOOKING WITH <br />CHAUFFER</h2>
                    </Grid>
                    <Grid className='srh-f-w' xs={12} md={6} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} >
                        <BookingForm />
                    </Grid>

                </Grid>
                </Grid>
            </div>

            <div className='about-us'>
                {/* <Container> */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} sx={12} >
                            <div className='about-us-img'>
                                <img src={AboutUs} style={{ }} alt="Hour Support" />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} sx={12}>
                            <div className='about-us-con'>
                                <h2 className='about-us-h'>ABOUT US</h2>
                                <Typography>Citi Lux Limousine is a Global service provider covering major world markets, utilizing a connected Network of owned and Affiliated companies providing quality Chauffeured transportation services worldwide. We are present in over 600 cities and 60 countries. With one corporate account or one personal profile you can travel the world in style and receive one invoice, chargeable to your credit card or direct bill to your company account. One call does it all. Book on line, use our App, send an email or have your corporate travel department download our App from Citi Lux Limo App.</Typography>
                                <button><a href="#">Read More</a></button>
                            </div>
                        </Grid>
                    </Grid>
                {/* </Container> */}
            </div>

            <div className='car-service'>
                <Container>
                    <h2>WE ARE PROVIDE PROFESSIONAL <br /> <span>CAR SERVICES</span></h2>
                </Container>
            </div>

            <div className='service'>
                <Container>
                    <Grid>
                        <div>
                            <h3>SERVICE</h3>
                            <Carousel responsive={responsive} className='service-carousel'>
                            <div className='service-img'>
                                <img src={ServiceOne} style={{ }} alt="Service" />
                                <div className='serive-content'>
                                    <div className='service-type'>
                                        <p>Private Service</p>
                                    </div>
                                    <div className='seat-count'>
                                        <span>4 Seater</span>
                                        <div className='seat-line'></div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-img'>
                                <img src={ServiceTwo} style={{ }} alt="Service" />
                                {/* <div className='serive-content'> */}
                                    <div className='service-type'>
                                        <p>Corporate Service</p>
                                    </div>
                                    <div className='seat-count'>
                                        <span>6 Seater</span>
                                        <div className='seat-line'></div>
                                    </div>
                                {/* </div> */}
                            </div>
                            <div className='service-img'>
                                <img src={ServiceThree} style={{ }} alt="Service" />
                                <div className='serive-content'>
                                <div className='service-type'>
                                    <p>Van Service</p>
                                </div>
                                    <div className='seat-count'>
                                        <span>16 Seater</span>
                                        <div className='seat-line'></div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-img'>
                                <img src={ServiceCar} style={{ }} alt="Service" />
                                <div className='serive-content'>
                                <div className='service-type'>
                                    <p>Car Service</p>
                                </div>
                                    <div className='seat-count'>
                                        <span>4 Seater</span>
                                        <div className='seat-line'></div>
                                    </div>
                                </div>
                            </div>
                            <div className='service-img'>
                                <img src={ServiceBus} style={{ }} alt="Service" />
                                <div className='serive-content'>
                                <div className='service-type'>
                                    <p>Bus Service</p>
                                </div>
                                    <div className='seat-count'>
                                        <span>18 Seater</span>
                                        <div className='seat-line'></div>
                                    </div>
                                </div>
                            </div>
                            </Carousel>
                        </div>
                    </Grid>
                </Container>
            </div>



            {/* limo services */}

            <div className="bg-gray" style={{display: 'none'}}>
                <Grid className='padd-r-l'>
                    <Grid container spacing={2} id="sec-con">
                        <Grid item xs={12} md={6} sx={12} >
                            <div className="sub-box">

                                {/* <div className="imges">
                                    <img src={Hoursupport} style={{ }} />
                                </div> */}
                                <div className="sec2-content">
                                    <h2>Singapore Limousine Maxicab Service</h2>
                                    <Typography>Singapore has become a tourist favourite, attracting people from all over the world.
                                    We providing luxury and comfort transport to our client to give them the best stay in Singapore.</Typography>
                                    <div className='read-more'>
                                        <a className='readmore-btn' href="#mainhome">Read more</a>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} sx={12}>
                            <div className="sub-box">
                                <div className="sec2-imgsec">
                                    <img src={benz_van} style={{  }} />
                                </div>
                                {/* <div className="sub-con">
                                    <h6>Qualified Assurance</h6>
                                    <p>All cars have a <br /> valid insurance.</p>
                                </div> */}
                            </div>
                        </Grid>
                        {/* <Grid item xs={12} md={4} sx={12} >
                            <div className="sub-box">
                                <div className="imges">
                                    <img src={Gps} style={{ }} />

                                </div>
                                <div className="sub-con">
                                    <h6>GPS on Cars</h6>
                                    <p>All cars are equipped with <br /> GPS navigation system.</p>
                                </div>
                            </div>
                        </Grid> */}
                    </Grid>
                </Grid>

            </div>
             {/* limo services */}

             {/* our fleet */}
             <div className='bg-white fleet' style={{display: 'none'}}>
                <Grid className='padd-r-l'>
                    <h2 className='sec-title mar-top-tit'>Our Fleet</h2>
                    <Grid container spacing={2} className="s-b m-t-high">
                        <Grid className='squre first-square' item xs={12} md={4} sx={12}>
                            <div class="sec3-car bmw-one">
                                <img src={bmw_one} style={{  }} />
                            </div>
                            <div class="sec3-content">
                                <h3>Economy Class</h3>
                                <Typography>The Mercedes E Class Limo Cab seats
                                    up to 5 passengers is a premium and 
                                    opulent Singapore limousine cab for the 
                                    traveler who has learned to demand the best.</Typography>
                                    <div className='fleet-btn'>
                                        <a href="#mainhome">Read more</a>
                                    </div>
                            </div>
                            <div item md={12} id="triangle-down">
                                <div class="emm">

                                </div>
                            </div>
                        </Grid>
                        <Grid className='squre box-active' item xs={12} md={4} sx={12}>
                            <div class="sec3-car car-two">
                                <img src={car_3} style={{  }} />
                            </div>
                            <div class="sec3-content">
                                <h3>Standard Class</h3>
                                <Typography>Spacious seating arrangements, often with reclining options and additional legroom. Seats may be arranged in private compartments or with extra privacy.</Typography>
                                    <div className='fleet-btn'>
                                        <a className='sec-read-m' href="#mainhome">Read more</a>
                                    </div>
                            </div>
                            <div item md={12} id="triangle-down">
                                <div class="emm">

                                </div>
                            </div>
                        </Grid>
                        <Grid className='squre' item xs={12} md={4} sx={12}>
                            <div class="sec3-car unique-top">
                                <img src={pngwing_1} style={{  }} />
                            </div>
                            <div class="sec3-content">
                                <h3>Business Class</h3>
                                <Typography>Complimentary meals and drinks, access to business lounges, Wi-Fi, and power outlets. Some services provide meeting tables and business facilities.</Typography>
                                <div className='fleet-btn'>
                                <a href="#mainhome">Read more</a>
                                </div>
                            </div>
                            <div item md={12} id="triangle-down">
                                <div class="emm">

                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
             </div>

             <div className="bg-gray sec-m-t" style={{display: 'none'}}>
                <Grid className='padd-r-l'>
                    <Grid container className="row mar-row">
                        <Grid item xs={12} md={6} sx={12}>
                            <div className="sec4-imag">
                                <img src={world_wide} alt="image" />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} sx={12} className="sec4-content">
                        <h2>World Class <span>LIMO SERVICE</span> in Singapore</h2>
                        <Typography>We offer an assorted armada to guarantee that you will find a 
                            vehicle to  meet your taste and facilities. You can book vehicles,
                            SUVs, stretch  limousines, buses, and small scale mentor
                            transports from us. All-round  perfectly maintained
                            armada with proficient drivers is what  differentiates us
                            from other Singapore limousine services.</Typography>
                            <div className='world-w-btn'>
                                    <a href="#mainhome">Read more</a>
                                </div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>

            <div className="bg-white" style={{display: 'none'}}>
                <Grid className='padd-r-l container'>
                <h2 class="w-c-h">Why Choose Us</h2>
                    <Grid container spacing={2} className="s-b m-t-60">
                        <Grid item xs={12} md={4} sx={12} className='box-icon'>
                            <div className="icon-img">
                            <svg width="75" height="75" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="Vector" d="M49 0C42.5652 0 36.1935 1.26742 30.2485 3.7299C24.3036 6.19238 18.9018 9.8017 14.3518 14.3518C5.16249 23.5411 0 36.0044 0 49C0 61.9956 5.16249 74.459 14.3518 83.6482C18.9018 88.1983 24.3036 91.8076 30.2485 94.2701C36.1935 96.7326 42.5652 98 49 98C61.9956 98 74.459 92.8375 83.6482 83.6482C92.8375 74.459 98 61.9956 98 49C98 42.5652 96.7326 36.1935 94.2701 30.2485C91.8076 24.3036 88.1983 18.9018 83.6482 14.3518C79.0982 9.8017 73.6964 6.19238 67.7515 3.7299C61.8065 1.26742 55.4348 0 49 0ZM69.58 69.58L44.1 53.9V24.5H51.45V49.98L73.5 63.21L69.58 69.58Z" fill="#FF7A00"/>
                            </svg>
                            </div>
                            <h6>24 Hours Support</h6>
                            <Typography>We Support you Of all hours of the day</Typography>
                        </Grid>
                        <Grid item xs={12} md={4} sx={12} className='box-icon'>
                            <div className="icon-img">
                            <svg width="71" height="75" viewBox="0 0 86 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M55.4152 5.78305C53.885 3.97025 51.9822 2.51421 49.8385 1.51568C47.6949 0.517159 45.3615 0 43 0C40.6385 0 38.3051 0.517159 36.1615 1.51568C34.0178 2.51421 32.115 3.97025 30.5848 5.78305L30.3566 6.05684C29.7983 6.71694 29.0924 7.23393 28.297 7.56524C27.5016 7.89654 26.6395 8.03269 25.7817 7.96245L25.4286 7.93508C23.0755 7.74502 20.7096 8.07231 18.4944 8.89431C16.2793 9.71632 14.2677 11.0134 12.5987 12.6959C10.9298 14.3784 9.64343 16.4062 8.82849 18.639C8.01356 20.8718 7.68955 23.2563 7.87885 25.6277L7.90059 25.9836C7.97027 26.8481 7.83519 27.717 7.50646 28.5186C7.17773 29.3202 6.66475 30.0316 6.00978 30.5943L5.73812 30.8243C3.93941 32.3665 2.49468 34.2842 1.50391 36.4446C0.513142 38.6051 0 40.9567 0 43.3367C0 45.7167 0.513142 48.0684 1.50391 50.2288C2.49468 52.3893 3.93941 54.3069 5.73812 55.8491L6.00978 56.0791C6.66475 56.6418 7.17773 57.3532 7.50646 58.1548C7.83519 58.9564 7.97027 59.8253 7.90059 60.6898L7.87342 61.0457C7.54978 65.1178 8.74214 69.1654 11.2181 72.3998C13.6941 75.6341 17.2763 77.8235 21.2666 78.5412V114.523C21.2665 115.515 21.5334 116.487 22.0388 117.338C22.5443 118.188 23.2694 118.885 24.1367 119.352C25.004 119.82 25.9811 120.042 26.9636 119.994C27.9461 119.945 28.8972 119.629 29.7155 119.079L43 110.154L56.2845 119.079C57.1028 119.629 58.0539 119.945 59.0364 119.994C60.0189 120.042 60.996 119.82 61.8633 119.352C62.7306 118.885 63.4557 118.188 63.9612 117.338C64.4666 116.487 64.7335 115.515 64.7334 114.523V78.5467C68.7247 77.8289 72.3077 75.6387 74.7838 72.4032C77.2599 69.1677 78.4516 65.1187 78.1266 61.0457L78.0994 60.6898C78.0297 59.8253 78.1648 58.9564 78.4935 58.1548C78.8223 57.3532 79.3352 56.6418 79.9902 56.0791L80.2619 55.8491C82.0606 54.3069 83.5053 52.3893 84.4961 50.2288C85.4869 48.0684 86 45.7167 86 43.3367C86 40.9567 85.4869 38.6051 84.4961 36.4446C83.5053 34.2842 82.0606 32.3665 80.2619 30.8243L79.9902 30.5943C79.3352 30.0316 78.8223 29.3202 78.4935 28.5186C78.1648 27.717 78.0297 26.8481 78.0994 25.9836L78.1266 25.6277C78.3152 23.2562 77.9904 20.8718 77.1748 18.6393C76.3592 16.4067 75.0722 14.3794 73.4027 12.6974C71.7333 11.0154 69.7213 9.71894 67.5059 8.89762C65.2904 8.07631 62.9244 7.74976 60.5714 7.94055L60.2183 7.96245C59.3605 8.03269 58.4984 7.89654 57.703 7.56524C56.9076 7.23393 56.2017 6.71694 55.6434 6.05684L55.4152 5.78305ZM32.1333 104.294V82.4893C35.1229 85.181 38.9912 86.6688 43 86.6688C47.0088 86.6688 50.8771 85.181 53.8667 82.4893V104.283L46.0155 99.0101C45.1226 98.4097 44.0733 98.0893 43 98.0893C41.9267 98.0893 40.8774 98.4097 39.9845 99.0101L32.1333 104.294ZM57.7081 41.7323C58.6978 40.6995 59.2454 39.3163 59.2331 37.8805C59.2207 36.4448 58.6493 35.0713 57.6419 34.0561C56.6345 33.0408 55.2717 32.4649 53.8471 32.4524C52.4225 32.4399 51.0501 32.9919 50.0253 33.9894L37.5667 46.5456L35.9747 44.9411C34.9499 43.9437 33.5775 43.3917 32.1529 43.4042C30.7283 43.4167 29.3655 43.9926 28.3581 45.0079C27.3507 46.0231 26.7793 47.3966 26.7669 48.8323C26.7546 50.2681 27.3022 51.6513 28.2919 52.6841L33.7253 58.1599C34.7442 59.1865 36.1259 59.7632 37.5667 59.7632C39.0074 59.7632 40.3891 59.1865 41.408 58.1599L57.7081 41.7323Z" fill="#FF7A00"/>
                                </svg>
                            </div>
                            <h6>Qualified Assurance</h6>
                            <Typography>All Cars have a Valid Insurance</Typography>
                        </Grid>
                        <Grid item xs={12} md={4} sx={12} className='box-icon'>
                            <div className="icon-img">
                            <svg width="75" height="75" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M49 96C74.9581 96 96 74.9581 96 49C96 23.0419 74.9581 2 49 2C23.0419 2 2 23.0419 2 49C2 74.9581 23.0419 96 49 96Z" fill="#FF7A00" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M48.9998 23.1504L32.5498 72.5004L48.9998 60.7504L65.4498 72.5004L48.9998 23.1504Z" fill="#FF7A00" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            </div>
                            <h6>GPS On Cars</h6>
                            <Typography>All cars are equipped with GPS navigation system</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <Footer />
        </div>
    )
}

export default Home
